module.exports = __webpack_public_path__ + "media/tiktok-ads.58803421.mp4";